import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class SocialCommunication extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Social Communication & Behaviour Modification</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Social Communication & Behaviour Modification</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Social Communication & Behaviour Modification</h2>

                      <p>
                        Social Communication and Behaviour Modification is a specialized intervention
                        designed to help children improve their communication abilities, social
                        interaction skills, and behavioural responses. The program focuses on
                        teaching children how to communicate effectively, understand social
                        situations, manage emotions, and develop appropriate behaviours that enhance
                        their participation in everyday life.
                      </p>

                      <p>
                        Children with developmental delays, autism spectrum disorder, ADHD, learning
                        disabilities, and social-emotional difficulties often face challenges in
                        expressing themselves, understanding others, following social rules, and
                        managing behaviours. Through individualized intervention strategies,
                        children learn essential skills that promote independence, confidence, and
                        meaningful relationships.
                      </p>

                      <div className="row">

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Who Can Benefit?</h3>

                          <ul>
                            <li>Children with developmental delays</li>
                            <li>Autism Spectrum Disorder (ASD)</li>
                            <li>Cerebral Palsy</li>
                            <li>ADHD</li>
                            <li>Speech and language delays</li>
                            <li>Learning disabilities</li>
                          </ul>
                        </div>

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Our Goals</h3>

                          <ul>
                            <li>Promote physical and cognitive development</li>
                            <li>Improve communication skills</li>
                            <li>Develop social and emotional abilities</li>
                            <li>Encourage independence</li>
                            <li>Prepare children for school and daily life</li>
                            <li>Support families through early guidance</li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default SocialCommunication;
